/**
 * Attachment button component
 * Plus icon button to attach images from photo library
 */

import React from 'react';
import { css } from '@emotion/react';
import { colors } from '../../../styles';

interface AttachmentButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const AttachmentButton: React.FC<AttachmentButtonProps> = ({ onClick, disabled = false }) => {
  return (
    <button onClick={onClick} disabled={disabled} css={buttonStyle(disabled)} aria-label="Attach image" type="button">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    </button>
  );
};

const buttonStyle = (disabled: boolean) => css`
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  border: none;
  background: ${colors.petrolBlue};
  color: ${colors.snow};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${disabled ? 'not-allowed' : 'pointer'};
  flex-shrink: 0;
  transition: all 0.2s ease;
  padding: 0;

  svg {
    color: ${colors.snow};
  }

  &:hover:not(:disabled) {
    opacity: 0.9;
    transform: scale(1.05);
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  &:disabled {
    opacity: 0.5;
  }

  html[data-theme='dark'] & {
    background: ${colors.skyBlue};
  }
`;

export default AttachmentButton;
